import { combineReducers } from 'redux';
import { SEND_RECEIPT, SEND_RECEIPT_ERROR, SEND_RECEIPT_SUCCESS, SHOW_RECEIPT } from './constants';
import booleanReducer from '../../common/reducers/booleanReducer';
import valueReducer from '../../common/reducers/valueReducer';

const error = booleanReducer(
  false,
  [SEND_RECEIPT_ERROR],
  [SEND_RECEIPT, SEND_RECEIPT_SUCCESS]
);

const loading = booleanReducer(
  false,
  [SEND_RECEIPT],
  [SEND_RECEIPT_SUCCESS, SEND_RECEIPT_ERROR]
);

const receiptData = valueReducer(
  {},
  SHOW_RECEIPT,
);

const reducer = combineReducers({
  error,
  loading,
  receiptData,
});

export default reducer;
